"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.match");
var _apolloClient = require("@/apollo/apolloClient");
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _companyMutation = require("@/apollo/mutations/company-mutation");
var _userQuery = require("@/apollo/queries/user-query");
var _user = require("@/api/user");
var _v = _interopRequireDefault(require("uuid/v4"));
var _checkExt = require("../../utils/check-ext");
var _validate = require("@/utils/validate");
var strings = _interopRequireWildcard(require("@/utils/strings"));
var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));
var _auth = require("../../utils/auth");
var _DateSelect = _interopRequireDefault(require("@/components/DateSelect/DateSelect.vue"));
var _date = require("@/utils/date.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AffiliationGroup: _AffiliationGroup.default,
    DateSelect: _DateSelect.default
  },
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this;
    var accountCheck = function accountCheck(rule, value, callback) {
      if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角英数字で入力してください'));
      } else {
        if (value.length < rule.minLen) {
          callback(error(rule.colname + 'は' + rule.minLen + '文字以上で入力してください'));
        } else if (value.length > rule.maxLen) {
          callback(error(rule.colname + 'は' + rule.maxLen + '文字以下で入力してください'));
        }
        _apolloClient.apolloClient.query({
          query: _userQuery.ACCOUNT_FOUND,
          variables: {
            id: value
          }
        }).then(function (result) {
          if (result.data.user.length > 0) {
            callback(new Error('すでに登録されているIDです。'));
          } else {
            callback();
          }
        }).catch(function (error) {
          callback(new Error(error));
        });
      }
    };
    var validateRequire = function validateRequire(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を入力してください'));
      } else {
        callback();
      }
    };
    var validateRequireOption = function validateRequireOption(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };
    var checkHanEisu = function checkHanEisu(rule, value, callback) {
      if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角英数字で入力してください'));
      } else {
        if (value.length < rule.minLen) {
          callback(error(rule.colname + 'は' + rule.minLen + '文字以上で入力してください'));
        } else if (value.length > rule.maxLen) {
          callback(error(rule.colname + 'は' + rule.maxLen + '文字以下で入力してください'));
        }
        callback();
      }
    };
    var checkHanEisuEx = function checkHanEisuEx(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }
      if (_this.$data.form.password !== _this.$data.password_org) {
        if (_this.$data.form.password !== value) {
          callback(error('会員パスワードと会員パスワード（確認用）が異なります。'));
        }
      }
      callback();
    };
    var error = function error(message) {
      return new Error(message);
    };
    return {
      keyAffiliation: 0,
      pathAffiliationList: [],
      saveAffiliationList: [],
      drawer: false,
      passwordType: 'password',
      confirmationPasswordType: 'password',
      company_id: null,
      fileAvatar: [],
      // アバター
      create_uid: '',
      phone_number: '',
      upload_fax: '',
      upload_mobile: '',
      space: '　',
      form: {
        uid: '',
        company_id: '',
        avatar: '',
        // 会員写真
        full_name: '',
        // 会員名
        full_name_furigana: '',
        // 会員名（ふりがな）
        birthday: '',
        position: '',
        // 役職名
        mobile_phone: '',
        // 携帯番号
        id: '',
        // ログインID
        password: '',
        // ログインパスワード
        confirmation_password: '',
        is_display: '',
        // アプリへの会員表示の有無
        is_active: '',
        // 会員の管理
        company: {
          id: '',
          // 会社ID
          website: '',
          // ホームページ
          business_descriptions: '',
          // 事業内容
          capital_stock: '',
          // 資本金（任意）
          email: '',
          // E-mail
          employees: '',
          // 社員数（任意）
          employees_part_time: '',
          // パート（任意）
          established: '',
          // 会社創立年月日
          fax1: '',
          // 会社FAX
          fax2: '',
          // 会社FAX
          fax3: '',
          // 会社FAX
          name: '',
          // 会員企業名
          name_furigana: '',
          // 会員企業名（ふりがな）
          address_1: '',
          // 会社住所
          address_2: '',
          // ビル名
          phone_number1: '',
          // 会社TEL
          phone_number2: '',
          // 会社TEL
          phone_number3: '',
          // 会社TEL
          join_date: '',
          // 入会年月日
          industry: '',
          // 職種コード
          mobile_phone1: '',
          // 携帯番号
          mobile_phone2: '',
          // 携帯番号
          mobile_phone3: '',
          // 携帯番号
          postcode1: '',
          // 会社郵便番号
          postcode2: '',
          // 会社郵便番号
          industries: {
            id: '',
            // 職種ID
            name: '',
            // 職種
            group_id: '',
            // グループID
            code: ''
          },
          created_at: '' // 作成日時
        }
      },
      waitDialogVisible: false,
      addDialogVisible: false,
      companyMode: true,
      period: [{
        scope: ''
      }],
      textOrganization: '',
      textOrganizationShibu: '',
      textOrganizationChiku: '',
      errorMessageOrganization: '',
      checkNumber: function checkNumber(rule, value, callback) {
        if (_this.isNumber(value) === false && value.length > 0) {
          callback(error(rule.colname + 'は半角数字で入力してください'));
        } else {
          callback();
        }
      },
      validateRequire: function validateRequire(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を入力してください'));
        } else {
          callback();
        }
      },
      validateRequirePhone: function validateRequirePhone(rule, value, callback) {
        if (value.length === 0) {
          callback(error(rule.colname + 'を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      tel1: function tel1(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      tel2: function tel2(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      tel3: function tel3(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }
        callback();
      },
      postcode1: function postcode1(rule, value, callback) {
        if (_this.isNumber(value) === false) {
          callback(error('郵便番号は、半角数字で入力してください'));
          return;
        }
        if (value.length !== 3) {
          callback(error(rule.colname + '桁数は３桁で入力してください'));
          return;
        }
        callback();
      },
      postcode2: function postcode2(rule, value, callback) {
        if (_this.isNumber(value) === false) {
          callback(error('郵便番号は、半角数字で入力してください'));
          return;
        }
        if (value.length !== 4) {
          callback(error(rule.colname + '桁数は４桁で入力してください'));
          return;
        }
        callback();
      },
      validateRequireFax: function validateRequireFax(rule, value, callback) {
        if (_this.$data.form.company.fax1.length === 0 && _this.$data.form.company.fax2.length === 0 && _this.$data.form.company.fax3.length === 0) {
          _this.$data.upload_fax = (0, _v.default)();
          callback();
          return;
        }
        if (value.length === 0) {
          callback(error(rule.colname + 'に値を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      validateRequireMobile: function validateRequireMobile(rule, value, callback) {
        if (_this.$data.form.company.mobile_phone1.length === 0 && _this.$data.form.company.mobile_phone2.length === 0 && _this.$data.form.company.mobile_phone3.length === 0) {
          _this.$data.upload_mobile = (0, _v.default)();
          callback();
          return;
        }
        if (value.length === 0) {
          callback(error(rule.colname + 'に値を入力してください'));
          return;
        }
        if (_this.isNumber(value) === false) {
          callback(error(rule.colname + 'は、半角数字で入力してください'));
          return;
        }
        callback();
      },
      checkDate: function checkDate(rule, value, callback) {
        if (value === '' || value === null) {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      validateRequireOption: function validateRequireOption(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      email: function email(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
        }
        if (!value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }
        callback();
      },
      url: function url(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
        }
        if (!value.match(/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }
        callback();
      },
      rules: {
        full_name: [{
          required: true,
          validator: validateRequire,
          colname: '会員名'
        }],
        full_name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '会員名（ふりがな）'
        }],
        id: [{
          required: true,
          validator: accountCheck,
          colname: '会員ID',
          minLen: 4,
          maxLen: 8
        }],
        password: [{
          required: true,
          validator: checkHanEisu,
          colname: '会員パスワード',
          minLen: 4,
          maxLen: 8
        }],
        confirmation_password: [{
          required: true,
          validator: checkHanEisuEx,
          colname: '会員パスワード（確認用）',
          minLen: 4,
          maxLen: 8
        }],
        is_display: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへの会員表示の有無'
        }],
        is_active: [{
          required: true,
          validator: validateRequireOption,
          colname: '会員の管理'
        }]
      }
    };
  },
  computed: {
    coms: function coms() {
      return this.$store.getters.companies;
    },
    industry_major: function industry_major() {
      return this.$store.getters.industryMajorOptions;
    },
    industry_middle: function industry_middle() {
      return this.$store.getters.industryMiddleOptions;
    },
    industry_info: function industry_info() {
      return this.$store.getters.industryInfo;
    },
    displays: function displays() {
      return this.$store.getters.displayOptions;
    },
    logins: function logins() {
      return this.$store.getters.loginOptions;
    },
    company: function company() {
      return this.$store.getters.company;
    },
    detail: function detail() {
      return this.$store.companyDetail;
    },
    zoneInfo: function zoneInfo() {
      return this.$store.getters.zoneInfo;
    },
    futureTimeCheck: function futureTimeCheck() {
      return {
        disabledDate: function disabledDate(date) {
          return (0, _validate.year_month_day)(date) > (0, _validate.year_month_day)(new Date());
        }
      };
    }
  },
  created: function created() {
    if (this.$store.getters.roles.indexOf('editor') >= 0) {
      this.companyMode = true;
    } else {
      this.companyMode = false;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var hasSearchCondition;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.$store.dispatch('user/GET_USER_DETAIL_INFO_QUERY', (0, _auth.getCompanyUID)());
          case 1:
            _context.n = 2;
            return this.$store.commit('company/setEnableTextAllSelect', false);
          case 2:
            hasSearchCondition = !!this.$store.getters.companieSearching || !!this.$store.state.company.majorCode || !!this.$store.state.company.middleCode || this.$store.state.company.pathToListItem.length > 0;
            if (!hasSearchCondition) {
              this.$store.commit('company/pathToListItem', []);
            }
            _context.n = 3;
            return this.$store.dispatch('company/getDisplayList');
          case 3:
            _context.n = 4;
            return this.$store.dispatch('company/getLoginList');
          case 4:
            _context.n = 5;
            return this.$store.dispatch('company/getIndustryMajorList');
          case 5:
            this.textOrganization = strings.textChangeByZone().textBranchAreaByZone;
            this.textOrganizationShibu = strings.textChangeByZone().branchMassage;
            this.textOrganizationChiku = strings.textChangeByZone().areaMessage;
          case 6:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    validateJoinDate: function validateJoinDate(rule, value, callback) {
      var dateParts = (0, _date.parseDateString)(value);
      var errorMessage = (0, _date.validateDateParts)(dateParts);
      if (errorMessage) {
        callback(new Error(errorMessage));
        return;
      }
      callback();
    },
    validateEstablished: function validateEstablished(rule, value, callback) {
      var dateParts = (0, _date.parseDateString)(value);
      var errorMessage = (0, _date.validateDateParts)(dateParts, false);
      if (errorMessage) {
        callback(new Error(errorMessage));
        return;
      }
      callback();
    },
    toCallbackWithErrorAffiliation: function toCallbackWithErrorAffiliation() {
      // / 組織を作成するための条件が満たされていない場合は、エラーを報告してください
      var valueAffiliation = this.pathAffiliationList;
      if (valueAffiliation.length === 0) {
        this.errorMessageOrganization = '組織を選択してください。';
        return true;
      }
      this.errorMessageOrganization = '';
      return false;
    },
    deleteItemAffiliation: function deleteItemAffiliation(item, index) {
      // 父親が削除されると、子供も削除されます
      var indexSplice = 1;
      for (var i = index + 1; i < this.pathAffiliationList.length; i++) {
        if (this.pathAffiliationList[i].paddingFloorInTreeAffiliation > item.paddingFloorInTreeAffiliation) {
          indexSplice = indexSplice + 1;
        } else break;
      }
      this.pathAffiliationList.splice(index, indexSplice);
      this.toCallbackWithErrorAffiliation();
    },
    swapAffiliationComponent: function () {
      var _swapAffiliationComponent = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(data) {
        var _this2 = this;
        var listPathOriginalAffiliation, pathFromDepth, setAffiliation;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.drawer = !this.drawer;
              if (this.drawer) this.$store.commit('company/pathToListItem', []);else this.keyAffiliation++;
              listPathOriginalAffiliation = this.$store.getters.pathToListItem;
              if (!(listPathOriginalAffiliation.length !== 0 && listPathOriginalAffiliation && this.drawer === false)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, listPathOriginalAffiliation);
            case 1:
              pathFromDepth = _context2.v;
              if (this.pathAffiliationList.length !== 0) {
                setAffiliation = pathFromDepth.filter(function (val) {
                  return _this2.pathAffiliationList.some(function (entire) {
                    return val.id === entire.id;
                  }) === false;
                });
                if (setAffiliation.length !== 0) setAffiliation.forEach(function (item) {
                  return _this2.pathAffiliationList.push(item);
                });
              } else this.pathAffiliationList = pathFromDepth;
              this.pathAffiliationList.sort(function (a, b) {
                return a.idFake - b.idFake;
              });
              // / 組織を選択するときに通知を表示または非表示にする
              this.toCallbackWithErrorAffiliation();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function swapAffiliationComponent(_x) {
        return _swapAffiliationComponent.apply(this, arguments);
      }
      return swapAffiliationComponent;
    }(),
    showPwd: function showPwd() {
      var _this3 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this3.$refs.password.focus();
      });
    },
    showConfirmationPwd: function showConfirmationPwd() {
      var _this4 = this;
      if (this.confirmationPasswordType === 'password') {
        this.confirmationPasswordType = '';
      } else {
        this.confirmationPasswordType = 'password';
      }
      this.$nextTick(function () {
        _this4.$refs.confirmationPassword.focus();
      });
    },
    changeIndustryMajor: function () {
      var _changeIndustryMajor = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.$store.dispatch('company/getIndustryMiddleList', {
                group_id: this.$data.form.company.industries.group_id
              });
            case 1:
              this.$data.form.company.industry = this.$store.getters.industryMiddleOptions[0].code;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function changeIndustryMajor() {
        return _changeIndustryMajor.apply(this, arguments);
      }
      return changeIndustryMajor;
    }(),
    getExtension: function getExtension(fileName) {
      var ret;
      if (!fileName) {
        return ret;
      }
      var fileTypes = fileName.split('.');
      var len = fileTypes.length;
      if (len === 0) {
        return ret;
      }
      ret = fileTypes[len - 1];
      return ret;
    },
    handleRemoveAvatar: function handleRemoveAvatar(file, fileList) {
      this.log('handleRemoveAvatar');
      this.fileAvatar = fileList;
    },
    handleDeleteAvatar: function handleDeleteAvatar(file, fileList) {
      this.log('handleDeleteAvatar');
      this.fileAvatar = fileList;
    },
    handleAddAvatar: function handleAddAvatar(file, fileList) {
      this.log('handleAddAvatar');
      if ((0, _checkExt.checkExtImage)(file.name)) {
        this.fileAvatar = fileList;
      } else {
        this.fileAvatar = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 2000
        });
      }
    },
    postFromCheck: function postFromCheck() {
      var _this5 = this;
      this.log(this.form);
      // エラーが発生した場合は停止します
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this5.toCallbackWithErrorAffiliation()) return;
          _this5.addDialogVisible = true;
        } else {
          _this5.log('error submit!!');
          _this5.toCallbackWithErrorAffiliation();
          return false;
        }
      });
    },
    onAdd: function () {
      var _onAdd = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _this6 = this;
        var employees, employees_part_time, establishedValue, established, is_birthday, join_date, objects, fileAvatarURL;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.waitDialogVisible = true;
              this.addDialogVisible = false;
              employees = 0;
              if (this.$data.form.company.employees === '' || this.$data.form.company.employees === null || this.$data.form.company.employees === undefined) {
                employees = null;
              } else {
                employees = this.$data.form.company.employees;
              }
              employees_part_time = 0;
              if (this.$data.form.company.employees_part_time === '' || this.$data.form.company.employees_part_time === null || this.$data.form.company.employees_part_time === undefined) {
                employees_part_time = null;
              } else {
                employees_part_time = this.$data.form.company.employees_part_time;
              }
              establishedValue = String(this.$data.form.company.established || '').trim();
              established = establishedValue || null;
              is_birthday = null;
              if (this.$data.form.birthday) {
                is_birthday = new Date(this.$data.form.birthday).toLocaleString({
                  timeZone: 'Asia/Tokyo'
                });
              }
              join_date = String(this.$data.form.company.join_date || '').trim();
              if (join_date) {
                _context4.n = 1;
                break;
              }
              this.waitDialogVisible = false;
              this.$notify({
                title: 'エラー',
                message: '入会年月は必須です。',
                type: 'error',
                duration: 2000
              });
              return _context4.a(2);
            case 1:
              objects = [{
                avatar: fileAvatarURL,
                full_name: this.$data.form.full_name,
                full_name_furigana: this.$data.form.full_name_furigana,
                position: this.$data.form.position,
                mobile_phone: this.$data.form.mobile_phone,
                birthday: is_birthday,
                id: this.$data.form.id,
                password: (0, _user.encrypt)(this.$data.form.password),
                is_display: this.$data.form.is_display,
                is_active: this.$data.form.is_active,
                company: {
                  data: {
                    name: this.$data.form.company.name,
                    name_furigana: this.$data.form.company.name_furigana,
                    phone_number: this.$data.form.company.phone_number1 + '-' + this.$data.form.company.phone_number2 + '-' + this.$data.form.company.phone_number3,
                    mobile_phone: this.$data.form.company.mobile_phone1 + '-' + this.$data.form.company.mobile_phone2 + '-' + this.$data.form.company.mobile_phone3,
                    fax: this.$data.form.company.fax1 + '-' + this.$data.form.company.fax2 + '-' + this.$data.form.company.fax3,
                    email: this.$data.form.company.email,
                    website: this.$data.form.company.website,
                    postcode: this.$data.form.company.postcode1 + '-' + this.$data.form.company.postcode2,
                    address_1: this.$data.form.company.address_1,
                    address_2: this.$data.form.company.address_2,
                    business_descriptions: this.$data.form.company.business_descriptions,
                    capital_stock: this.$data.form.company.capital_stock,
                    employees: employees,
                    employees_part_time: employees_part_time,
                    established: established,
                    join_date: join_date,
                    industry: this.$data.form.company.industry
                  }
                }
              }];
              _context4.n = 2;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.ADD_MEMBER,
                variables: {
                  objects: objects
                }
              }).then(function (result) {
                _this6.create_uid = result.data.insert_user.returning[0].uid;
                var objectsAffilication = [];
                var listAffiliationId = [];
                if (_this6.pathAffiliationList.length !== 0) {
                  _this6.pathAffiliationList.map(function (item) {
                    listAffiliationId.push(item.id);
                    objectsAffilication.push({
                      affiliation_id: item.id,
                      user_id: _this6.create_uid
                    });
                  });
                  _apolloClient.apolloClient.mutate({
                    mutation: _companyMutation.USER_AFFILIATION_INSERT_UPDATE,
                    variables: {
                      user_id: _this6.create_uid,
                      affiliation_ids: listAffiliationId,
                      objects: objectsAffilication
                    }
                  }).then(function () {
                    _this6.log(JSON.stringify(objectsAffilication));
                    _this6.waitDialogVisible = false;
                    _this6.$notify({
                      title: '情報',
                      message: '会員情報の登録が完了しました。',
                      type: 'success',
                      duration: 2000
                    });
                    return _this6.$router.push({
                      name: 'Company'
                    });
                  });
                }
              }).catch(function (error) {
                _this6.waitDialogVisible = false;
                _this6.$notify({
                  title: '情報',
                  message: '会員情報の登録に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.log(error);
                return;
              });
            case 2:
              fileAvatarURL = null;
              if (!(this.fileAvatar.length > 0)) {
                _context4.n = 5;
                break;
              }
              _context4.n = 3;
              return this.uploadFileToStorage(this.fileAvatar[0].raw, 'users/avatar/avatar_' + this.create_uid + '.jpg');
            case 3:
              fileAvatarURL = _context4.v;
              if (!(fileAvatarURL == null)) {
                _context4.n = 4;
                break;
              }
              console.log('画像のアップロードに失敗しました。');
              this.waitDialogVisible = false;
              return _context4.a(2);
            case 4:
              _context4.n = 5;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.UPDATE_MEMBER,
                variables: {
                  uid: this.create_uid,
                  objects: {
                    avatar: fileAvatarURL
                  }
                }
              }).catch(function (error) {
                _this6.$notify({
                  title: '情報',
                  message: '会員情報の更新に失敗しました。',
                  type: 'error',
                  duration: 2000
                });
                _this6.waitDialogVisible = false;
                _this6.log(error);
                return;
              });
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onAdd() {
        return _onAdd.apply(this, arguments);
      }
      return onAdd;
    }(),
    isNumber: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    },
    isHanEisu: function isHanEisu(str) {
      str = str === null ? '' : str;
      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },
    log: function log(text) {}
  }
};